interface ApiStatusError {
  status_code?: string;
  message?: string;
  response?: {
    status?: number;
  };
}

export const getApiErrorMessage = (error: unknown): string | undefined => {
  const apiError = error as ApiStatusError;
  return typeof apiError?.message === 'string' && apiError.message.length > 0 ? apiError.message : undefined;
};

export const isExtensionConflictError = (error: unknown): boolean => {
  return (error as ApiStatusError)?.status_code === 'conflict';
};

export const isLoanNotFoundError = (error: unknown): boolean => {
  const apiError = error as ApiStatusError;
  return apiError?.status_code === 'not_found' || apiError?.response?.status === 404;
};

export const isExtensionStaleStateError = (error: unknown): boolean => {
  return isExtensionConflictError(error) || isLoanNotFoundError(error);
};
